import { apiClient } from '../../core/api';
import type {
  IntegrationActivationPayload,
  UserProfile,
  IntegrationActivationResponse,
} from '../../../types/auth';
import { useAuthStore } from '../../../stores/authStore';

export const activateIntegration = async (
  platform: string,
  payload: IntegrationActivationPayload
): Promise<IntegrationActivationResponse> => {
  try {
    const response = await apiClient.chatbotPost<IntegrationActivationResponse>(
      `/integration/activate?platform=${platform}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Integration activation failed:', error);
    throw error;
  }
};

export const hasUninstalledShopify = (user: UserProfile | null): boolean => {
  console.log('Integration hasUninstalledShopify:', user);
  return !(
    !user ||
    user.installations.some(
      installation => installation.platform === 'shopify' && installation.status !== 'uninstalled'
    )
  );
};

/**
 * Complete an onboarding step by step name (new API)
 * @param userId - User ID
 * @param stepName - Step name to mark as completed
 * @param existingStepNames - Array of already completed step names
 * @returns Updated user profile
 */
export const completeOnboardingStepByName = async (
  userId: string,
  stepName: string,
  existingStepNames: string[] = []
): Promise<UserProfile> => {
  try {
    // 确保不重复添加已存在的步骤
    const uniqueSteps = [...new Set([...existingStepNames, stepName])];
    const combinedStepNames = uniqueSteps.filter(Boolean).join(',');

    console.log('🔄 Completing onboarding step:', {
      userId,
      newStep: stepName,
      existingSteps: existingStepNames,
      uniqueSteps,
      combinedStepNames,
    });

    const response = await apiClient.chatbotPost<UserProfile>(
      `/integration/onboarding-step/${userId}`,
      { stepName: combinedStepNames }
    );

    console.log('✅ Onboarding step completed successfully:', response.data);

    // Update auth store
    if (response.data) {
      useAuthStore.getState().updateUserFromOnboarding(response.data);
    }

    return response.data;
  } catch (error) {
    console.error('❌ Onboarding step completion failed:', error);
    throw error;
  }
};
